<div class="meta-config-panel" @fadeSlideInOut style="position: absolute;">
  <button (click)="removeStyle()">Zurücksetzen</button>
  @for(style of styles(); track style.label) {
  <label>
    <span class="mat-label-medium">{{ style.label }}:</span>
  </label>
  <div class="meta-config-item">
    @if(style.options && style.options.length > 0) {
    <mat-select [(ngModel)]="style.value" (selectionChange)="updateStyle($event.value, style)" panelClass="admin-theme">
      <mat-option *ngFor="let option of style.options" [value]="option.value">{{ option.label }}</mat-option>
    </mat-select>
    } @else {
    <input [type]="style.inputType" [value]="style.value" (input)="updateStyle($event, style)" [min]="style.min"
      [max]="style.max" />
    }
    @if(style.inputType === 'color' && style.type == 'background-color') {
    <button (click)="updateStyle('transparent', style)">Transparent</button>
    }

  </div>
  }
  <button (click)="close()">Schließen</button>
</div>